import * as Sentry from '@sentry/vue'

let tracking = {
	trackEvent(message = {}) {
		Sentry.captureMessage(message)
	},
	addBreadcrumb(message, value = {}) {
		Sentry.addBreadcrumb({
				message: message,
				data: value
			}
		)
	}
}

export default tracking